import { collection, query, orderBy, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchMentorshipDrafts(uid) {
  const q = query(
    collection(db, 'artifacts', appId, 'users', uid, 'mentorship_drafts'),
    orderBy('createdAt', 'desc')
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function submitMentorshipDraft(uid, draft) {
  await addDoc(collection(db, 'artifacts', appId, 'users', uid, 'mentorship_drafts'), {
    ...draft,
    status: 'AWAITING_CORRECTION',
    createdAt: serverTimestamp(),
    studentName: draft.studentName || 'Aluno',
    studentEmail: draft.studentEmail,
  });
}
